<template>
  <div v-else class="location-dropdown-container">
    <p @click="open_location_block=true">{{ address }}</p>
    <div class="location-dropdown-container-hidden-block" v-if="open_location_block">
      <div id="map-box" class="address">
        <div class="input-wrapper notranslate">
          <label>
            <input
                v-show="true"
                class="form-control"
                type="text"
                name="address"
                :placeholder="trans('event_address')"
                :data-vv-as="trans('address')"
                v-model="address"
                v-validate="'required'"
                :class="{'is-invalid-input': errors.has('form1.address')}"
                @input="handleAddressModification"
                required
            />
            <span class="form-error" :class="{'is-visible': errors.has('form1.address')}">
                  {{ errors.first('form1.address') }}
                </span>
          </label>
        </div>
        <div class="map-box" :style="{'height': '250px'}">
          <Map
              :lat="lat"
              :lng="lng"
              :zoom="15"
              :styles="mapHeight"
              :clickable="true"
              :draggable="true"
              :options="mapOptions"
              :dragEnd="handleMapMarkerDrag"/>
          <div class="float-button">
            <button type="button" class="btn set-location" @click="setLocation">{{ trans('set_location') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapState} from "vuex";
    import Map from '@buddy/views/widgets/Map.vue';
    import eventsModule from "../../../events/module/store/type";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-events').default
        ],
        props: ['address_head', 'spots_lat', 'spots_lng'],
        computed:{
          mapHeight() {
            return  '250px';
          },
          mapOptions() {
            return {
              scrollWheelZoom: false,
              dragging: true,
              touchZoom: true
            }
          },
        },
        components:{
          Map,
        },
        methods: {
            setLocation() {
              this.open_location_block = false;
              this.resetSpot();
            },
            resetSpot(){
              app.$emit('reloadSpots')
            },
            async handleMapMarkerDrag(event) {
              let newLat, newLng;

              if (this.mapProviderIsGmap) {
                newLat = event.latLng.lat();
                newLng = event.latLng.lng();
              } else {
                newLat = event.target.getLatLng().lat;
                newLng = event.target.getLatLng().lng;
              }

              try {
                let fullInfo = await this.getAddressForLatLng(newLat, newLng, true);
                this.lat = newLat;
                this.lng = newLng;
                this.address = fullInfo.formattedAddress;
                this.addressError = null
                this.$emit('setSpotLocation',{lat:this.lat,lng:this.lng,address:this.address})
              } catch(e) {
                this.addressError = e
              }
            },
          handleAddressModification: _.debounce(async function (club){
            let lat, lng;
            if (!club.target.value) {
              return;
            }

            try {
              //update map marker
              this.addressShow = 'Location defining...';
              let fullInfo = await this.getLatLngForAddress(this.address, true);
              this.addressShow = this.address;
              ({lat, lng} = fullInfo.point);
              this.lat = parseFloat(lat);
              this.lng = parseFloat(lng);
              let v = this
              this.$emit('setSpotLocation',{lat:this.lat,lng:this.lng,address:this.address})
              setTimeout(function() {
                v.zoom = 15
              }, 500)
              this.addressError = null
            } catch(e) {
              this.addressError = e
            }
          }, 1000),
        },
        data (){
          return {
            open_location_block: false,
            address: this.address_head,
            addressError: '',
            lng : this.spots_lng,
            lat: this.spots_lat
          };
        },
      mounted(){

      }
    }
</script>
